// extracted by mini-css-extract-plugin
export default {"iconButton":"LLAEfVp9G4_static-pages","invert":"Eds0lBHm2b_static-pages","primary":"maMz2_m2Db_static-pages","secondary":"_aFev951W8_static-pages"};